import { AmuseLabs } from "./amuse_labs";
import { CORS } from "./cors";
import { Game } from "./game";

export class LAT {

  static load(cb: Function) {

    const date = new Date();
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    Game.puzzle.year = year;
    Game.puzzle.month = month;
    Game.puzzle.day = day;

    const month_name = Game.months[month - 1].toLowerCase();
    console.log(month_name);

    let month_str = month.toString();
    if (month_str.length < 2) {
      month_str = "0" + month_str;
    }
    let day_str = day.toString();
    if (day_str.length < 2) {
      day_str = "0" + day_str;
    }
    const date_id = "" + year + month_str + day_str;

    Game.puzzle.id = "lat" + date_id;
    Game.puzzle.date_string = date_id;

    const page = "https://cdn4.amuselabs.com/lat/date-picker?set=latimes&style=1&embed=1&heightReduction=30";

    const t0 = performance.now();

    const page_cb = function (data: string) {
      console.log("page load");

      // links like https://cdn4.amuselabs.com/lat/crossword?id=tca210405&set=latimes&embed=1&picker=date-picker&heightReduction=30&style=1

      // example link: https://cdn4.amuselabs.com/lat/crossword?id=tca211002&set=latimes&embed=1&picker=date-picker&heightReduction=30&style=1&src=https%3A%2F%2Fwww.latimes.com%2Fgames%2Fdaily-crossword&pickerToken=eyJ1aWQiOiIzNTNhMDhkMi0xMGRhLTQ5MDctOTMwYi0zOTI1MmNlMjJlYTYiLCJ1cGRhdGVMb2FkVGFibGUiOmZhbHNlLCJ0aW1lc3RhbXAiOjE2MzMxODc5NzUwNTl9

      const pickerPattern = "pickerParams.rawsps = '.+?'";
      const picker_re = new RegExp(pickerPattern);
      const picker_matches = data.match(picker_re);
      let picker_token = "";
      if (picker_matches && picker_matches.length > 0) {
        const match = picker_matches[0];
        let d = match.replace("pickerParams.rawsps = '", "");
        d = d.replace("'", "");
        const j = JSON.parse(atob(d));
        picker_token = j.pickerToken;
      }

      const pattern = 'data-id="\?.+ data';
      const re = new RegExp(pattern);
      const matches = data.match(re);
      if (matches && matches.length > 0) {
        const match = matches[0];
        const parts = match.split('data-id="');
        const id = parts[1].replace('" data', "");
        const url = "https://cdn4.amuselabs.com/lat/crossword?id=" + id + "&set=latimes&picker=date-picker&heightReduction=30&style=1&pickerToken=" + picker_token;

        CORS.load(url, data_cb);
      } else {
        console.log("Can't find id");
      }
    }

    const data_cb = function (data: string) {
      console.log("data load");
      const pattern = "window.rawc = '.+?'";
      const re = new RegExp(pattern);
      const matches = data.match(re);
      if (matches && matches.length > 0) {
        const match = matches[0];
        let d = match.replace("window.rawc = '", "");
        d = d.replace("'", "");
        const j = AmuseLabs.decode(d);
        AmuseLabs.parse(j);
        cb();
      } else {
        console.log("Can't find window.rawc");
      }
      console.log("load: " + (performance.now() - t0) + " ms");
    }

    CORS.load(page, page_cb);
  }



}